module.exports = __webpack_public_path__ + "img/ego_lego.706b6162.jpg";